import { render, staticRenderFns } from "./DIsputeResolutionFormDetailsBox.vue?vue&type=template&id=c42be12c&scoped=true&"
import script from "./DIsputeResolutionFormDetailsBox.vue?vue&type=script&lang=js&"
export * from "./DIsputeResolutionFormDetailsBox.vue?vue&type=script&lang=js&"
import style0 from "./DIsputeResolutionFormDetailsBox.vue?vue&type=style&index=0&id=c42be12c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42be12c",
  null
  
)

export default component.exports